import React from 'react'
import Header from '../Header/Header'
import RifasData from '../../Components/Admin/RifasData/RifasData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'

export default function Tiendas() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <RifasData />

                </div>
            </section>
        </div>
    )
}

